import React from "react";
import { createUniqueKey } from "../../../utils";

function Legend(props) {
    const {
        legend = [],
        singleAllocation = false,
        hideValues = false,
    } = props;

    return (
        <dl
            className={`legend ${singleAllocation ? "legend-single-item" : ""}`}
        >
            {legend.map((item, index) => (
                <div
                    className="legend-item"
                    key={createUniqueKey(index, item.label)}
                >
                    <dt className="legend-name">
                        {!singleAllocation && <div className="legend-point" />}
                        {item.label}
                    </dt>
                    {!hideValues && (
                        <dd className="legend-value">{item.percent}</dd>
                    )}
                </div>
            ))}
        </dl>
    );
}


export default Legend;
